import { render, staticRenderFns } from "./PostOpen.vue?vue&type=template&id=f34dcaf0&"
import script from "./PostOpen.vue?vue&type=script&lang=js&"
export * from "./PostOpen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports